import {createEvent, type Emitter, type Listener} from "react-event-hook";

export interface VideoEndedEventPayload {
    /**
     * The translatedTitle of the video.
     */
    title: string;
}

interface Event {
    /**
     * Listen for the video-complete event.
     */
    useVideoEndedListener: Listener<VideoEndedEventPayload>;
    /**
     * Emit the video-complete event.
     *
     * This event is raised by the video renderer to signal that the video being
     * watched has reached completion.
     */
    emitVideoEnded: Emitter<VideoEndedEventPayload>;
}

export const {useVideoEndedListener, emitVideoEnded} = createEvent(
    "video-ended",
)() as Event;
